var map = {
	"./RIDF_laurels.png": "19ee",
	"./RIDF_laurels_no_audience_winner.png": "0516",
	"./RaiPlay_logo.png": "bfd6",
	"./contact.jpg": "a53d",
	"./hero.jpg": "6ee5",
	"./icon.png": "555a",
	"./loader.gif": "fa5e",
	"./locandina.jpg": "c26c",
	"./locandina_cristina.jpg": "21e5",
	"./locandina_dorina.jpg": "8c08",
	"./locandina_fabio.jpg": "cbf6",
	"./logo_dear_mama.png": "d921",
	"./pediatria.png": "0f7c",
	"./special-content.jpg": "3992",
	"./trailer.jpg": "fbe7",
	"./video_placeholder.jpg": "f5e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";